
const clickEvent = () => (new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));

const adminLib = {

	/**
	 * Open a field Accordion by DIV and scrolls to it
	 * @param {HTMLElement} el The main DIV of a field
	 */
	editorScrollToField: el => {
		if ( el && el instanceof HTMLElement ) {
			const t = el.querySelector(':scope > .MyAccordion.collapsed > .MyAccordionHeader > .MyAccordionToggler');
			if ( t ) t.dispatchEvent( clickEvent() );
			el.scrollIntoView({block:"center"});
		}
	},

	/**
	 * Scroll to a field by its key
	 * @param {string} fKey The field key for the JSON
	 * @see adminLib.editorScrollToField
	 */
	editorScrollToFieldKey: fKey => {
		adminLib.editorScrollToField( window.document.querySelector(`.field[rel="field-${fKey}"]`) );
	},

	/**
	 * Scroll to a field by its ID
	 * @param {string} id The internal field.uuid generated in the editor
	 * @see adminLib.editorScrollToField
	 */
	editorScrollToFieldID: id => {
		adminLib.editorScrollToField( window.document.getElementById(id) );
	}

}

export default adminLib;
